import { Row } from "@tanstack/react-table";

type WithFirst<T> = T & { isFirstOfAType?: true };

// injects array with isFirstOfAType: true
export function markFirstOfType<T extends Record<string, any>>(
  arr: Row<T>[],
  groupBy?: string
): WithFirst<Row<T>>[] {
  if (!groupBy) return arr;

  const seen = new Set<T[keyof T]>();

  return arr.map((item) => {
    const value = item.original[groupBy];
    if (!seen.has(value)) {
      seen.add(value);
      return { ...item, isFirstOfAType: true };
    }
    return item;
  });
}
